import { trackEvent, trackPageview } from './events';
export class AnalyticsService {
  constructor(settings, history, isInitialized) {
    this.siteName = '';
    this.gtmCodes = [];
    this.siteName = settings.siteName;
    if (!isInitialized) {
      this.init(settings);
      this.initEvents();
      this.initRouteEvents(history);
    }
  }
  sendEvent(eventCategory, eventLabel, extraProps) {
    trackEvent(this.siteName, eventCategory, eventLabel, extraProps);
  }
  init(settings) {
    const urlPrefix = this.getUrlPrefix(settings.siteName);
    settings.gtmCodes.forEach(code => {
      const script = document.createElement('script');
      script.src = `${urlPrefix}/gtm-init.js?gtmId=${code}`;
      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          bblSite: settings.siteName,
          bbl: settings.bblCode,
          ngtApp: settings.ngtApp || false
        });
      };
      document.head.appendChild(script);
    });
  }
  initEvents() {
    window.addEventListener('click', evt => this.handleClickEvent(evt, this.siteName), false);
  }
  initRouteEvents(history) {
    /**
     * For initial load
     */
    trackPageview(this.siteName, history.location.pathname, document.title);

    /**
     * Route listener
     */
    history.listen((location, action) => {
      if (action === 'PUSH' || action === 'POP') {
        setTimeout(() => {
          trackPageview(this.siteName, location.pathname, document.title, location.search ? {
            search: location.search
          } : null);
        }, 100);
      }
    });
  }
  handleClickEvent(e, siteName) {
    if (e.target.closest('button')) {
      if (e.target.closest('button').dataset.trackingName) {
        trackEvent(siteName, e.target.closest('button').dataset.trackingEvent ? e.target.closest('button').dataset.trackingEvent : 'Click', e.target.closest('button').dataset.trackingName);
      }
    } else if (e.target.closest('a')) {
      if (e.target.closest('a').dataset.trackingName) {
        trackEvent(siteName, e.target.closest('a').dataset.trackingEvent ? e.target.closest('a').dataset.trackingEvent : 'Click', e.target.closest('a').dataset.trackingName);
      }
    } else if (e.target.closest('div[role="button"]')) {
      const tName = e.target.closest('div[role="button"]').dataset.trackingName;
      const tEvent = e.target.closest('div[role="button"]').dataset.trackingEvent;
      if (tName) {
        trackEvent(siteName, tEvent ? tEvent : 'Click', tName);
      }
    }
  }
  getUrlPrefix(siteName) {
    const urlPrefixes = {
      'min side': '/minside',
      portal: '/portal'
    };
    return urlPrefixes[siteName.toLowerCase()] || '';
  }
}